import {View} from 'MWC';
import tpl from './templates/interactive';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        return this;
    }

    static displayName = 'HappyATB';
}
